import type { ProLayoutProps } from '@ant-design/pro-components';
import { BizAppConfig } from './application.manifest';
import { getBrandAppName } from './brand';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#1890ff',
  layout: 'side',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  siderWidth: 180,
  pwa: true,
  title: getBrandAppName(),
  logo: BizAppConfig.appLogo,
  token: {},
  splitMenus: false,
};
export default Settings;
